module.exports = __webpack_public_path__ + "static/media/16_kent_li.2049a19f.jpeg";